/**
 * 변경 이력의 '등록 내용' 펼침 표시 (v2.043).
 *
 * 등록(INSERT) 줄에는 그 시점 행 전체가 audit_log.row_data(JSONB) 로 남아 있는데,
 * 지금까지 화면엔 "매입 등록" 한 줄만 뜨고 무엇을 등록했는지 볼 수 없었다.
 * (관리자 [변경 이력] 메뉴에는 이미 '전체 보기'가 있었고, 상세 창에만 빠져 있었다.)
 *
 * 값이 빈 칸은 감춘다 — 등록 시 채운 칸만 보이는 편이 읽기 쉽다.
 * 라벨은 관리자 화면과 같은 audit-labels 를 쓴다.
 */

import { getFieldLabel, formatAuditValue } from '../lib/audit-labels';

/** 화면에 띄울 이유가 없는 내부 칸 — 계산 결과·연결 키는 감춘다. */
const HIDDEN_KEYS = new Set<string>(['created_at', 'updated_at']);

export function AuditRowDataDetail({
  tableName,
  data,
  heading = '등록 당시 내용',
  formatValue,
}: {
  tableName: string;
  data: Record<string, unknown>;
  /** 머리 글 — 삭제 줄이면 「지울 때 내용」 (v2.279.0 · 유지보수 이력) */
  heading?: string;
  /** 값 표시 — 없으면 공용 formatAuditValue (유지보수 이력은 금액 「원」·연도 쉼표 없이 · lib/maint-audit) */
  formatValue?: (key: string, v: unknown) => string;
}) {
  const entries = Object.entries(data).filter(
    ([k, v]) => v !== null && v !== undefined && v !== '' && !HIDDEN_KEYS.has(k),
  );
  if (entries.length === 0) {
    return (
      <div className="mt-2 text-xs text-slate-500 border-l-2 border-slate-200 pl-3">
        등록 내용이 비어 있습니다.
      </div>
    );
  }
  return (
    <div className="mt-2 border-l-2 border-slate-200 pl-3">
      <div className="text-xs text-slate-500 mb-1">
        {heading} ({entries.length}개 항목)
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-0.5">
        {entries.map(([k, v]) => (
          <div key={k} className="flex gap-1.5 text-xs border-b border-slate-100 py-0.5">
            <span className="text-slate-500 min-w-[92px] shrink-0" title={k}>
              {getFieldLabel(tableName, k)}
            </span>
            <span className="text-slate-800 break-all">{formatValue ? formatValue(k, v) : formatAuditValue(v)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
